<template>
  <div id="ProductList" class="page product-list">
    <rate-feedback
        v-if="feedbackDialogVisible"
        :code="gjwCategoryCode"
        :title="gjwCategoryName"
        type="7"
        @close="closeFeedbackDialog" />
    <div class="search-box" >
      <!-- 性能筛选 -->
      <div class="search-block curve-block border-bottom-divide" v-if="curveFormItems && curveFormItems.length">
        <span class="label">性能</span>
         <curve-search
          ref="curveSearch"
          class="curve"
          :curve-form-items="curveFormItems"
          @curve-search="searchByCurve" />
      </div>
      <!-- 品牌 -->
      <div v-if="!brandCode && brands && brands.length" class="search-block border-bottom-divide">
        <span class="label">品牌</span>
        <div class="brand-content">
          <span
              v-for="item in brands"
              :key="item.brandCode"
              class="brand-tag"
              :class="{'active': selectBrand === item.brandCode, 'disabled': item.disabled}"
              @click="clickBrand(item)"
          >
            {{item.brandName}}
          </span>
        </div>
      </div>
      <!-- 属性筛选 -->
      <div class="search-block border-bottom-divide">
        <span class="label keyword-label">筛选</span>
        <filter-search ref="filterSearch" :search-properties="searchProperties" @select="onFilterSelected" @change="handleShowFilterSearch" />
      </div>
    </div>
    <div class="result-row">
      <!-- 筛选结果 -->
      <filter-result
        :gjw-category-code="gjwCategoryCode"
        :curve-properties="curveProperties"
        :curve-search-names="curveSearchNames"
        :product-properties="productProperties"
        :total-count="totalCount"
        @clear-curve-filter="clearCurveFilter"
        @clear-product-filter="clearProductFilter"
        @clear-deviation-filter="clearDeviationFilter"
        @clear-all-filters="clearAllFilters" />
    </div>
    <!-- 列表 -->
    <gjw-dimensions @height-changed="getTableBoxHeight">
      <div ref="tableBox" class="table-box">
        <el-table
            ref="fixedColTable"
            v-loading="productsLoading"
            :data="tableData"
            :max-height="tableHeight"
            class="row-click-table"
            style="width:100%;"
            @sort-change="onSortChange"
            @row-click="(row)=>toDetail(row)"
        >
          <el-table-column v-for="col in columns" :key="col.label" :label="col.label" :prop="col.prop" :formatter="fmtValue" :fixed='col.fixed' :min-width="col.minWidth" :sortable="col.sortable">
            <template v-if="col.templateName" v-slot="scope">
              <product-model-col v-if="col.templateName === 'model'" :row="scope.row" @image-click="toDetail" @model-click="toDetail" />
              <deviation-value v-if="col.templateName === 'deviation'" :row="scope.row" :relate-prop="col.templateData.relateProp"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="112px" fixed="right">
            <template v-slot="scope">
              <!-- <el-button v-if="!brandCode" plain class="table-button sub-primary" @click.stop="toSelected(scope.row, scope.$index)" :disabled="selectingIndex === scope.$index">选中</el-button> -->
              <template v-if="showResource">
                <el-tooltip v-if="showPlaceComp && !isFromEntrance" content="布置该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="toPlaceComponent(scope.row)">布置</el-button>
                </el-tooltip>
                <el-tooltip v-if="showPlaceCompG && !isFromEntrance" content="载入该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="toLoadGcsComp(scope.row)">载入</el-button>
                </el-tooltip>
                <el-tooltip v-if="isFromEntrance" content="选中该产品构件" placement="top">
                  <el-button plain class="table-button main-primary" @click.stop="selectGcsComp(scope.row)">选中</el-button>
                </el-tooltip>
                <el-popover
                    v-if="showPlaceCompWeb"
                    popper-class="no-padding-popper"
                    placement="bottom-end"
                    width="300"
                    trigger="hover"
                    @show="showPopover(scope.row)">
                  <source-list-popover :loading="resourceLoading" :resource="scope.row.resource" @handleClick="toDetail(scope.row)"/>
                  <template #reference>
                    <el-button type="primary" plain class="table-button main-primary pop-button" @click.stop="toDetail(scope.row)">下载</el-button>
                  </template>
                </el-popover>
              </template>
            </template>
          </el-table-column>
          <template #empty>
            <span v-if="selectedBrandUrl">非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
            <span v-else>非常抱歉，由于产品数据较少，未查询到符合条件的产品，您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
          </template>
          <template #append>
            <div v-if="showUnsatisfiedInfo" class="feedback-info">
              <span v-if="selectedBrandUrl">以上结果都不满足您的选型需求？您可以<em class="empty-list-feedback" @click="toFeedback">联系厂家</em>，留下产品需求和联系方式，厂家收到需求后会与您联系</span>
              <span v-else>对选型结果不满意？您可以填写<em class="empty-list-feedback" @click="toFeedback">反馈</em>，让我们帮您找到合适的产品</span>
            </div>
          </template>
        </el-table>
        <el-pagination
            small
            style="text-align: right; margin-top: 4px;"
            @current-change="currentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="totalCount">
        </el-pagination>
      </div>
    </gjw-dimensions>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions, mapMutations } from 'vuex'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import productListMixin from '@/mixins/productListMixin'
import productDetailMixin from '@/mixins/productDetailMixin'
import keepAlivePageMixin from '@/mixins/keepAlivePageMixin'
import defaultViewMixin from '@/mixins/defaultViewMixin'
import GjwDimensions from '@/components/lib/GjwDimensions'
import SourceListPopover from './components/SourceListPopover'
import DeviationValue from './components/DeviationValue.vue'
import CurveSearch from '@/views/products/components/CurveSearch'
import FilterSearch from '@/views/products/components/FilterSearch'
import FilterResult from '@/views/products/components/FilterResult'
import ProductModelCol from '@/views/products/components/ProductModelCol'
import ProductStrategy from '@/views/products/strategy/ProductStrategy'
import RateFeedback from "./components/RateFeedback.vue"
export default {
  name: 'ProductList',
  components: { RateFeedback, GjwDimensions, SourceListPopover, DeviationValue, CurveSearch, FilterSearch, FilterResult, ProductModelCol },
  mixins: [checkLoginMixin, productListMixin, keepAlivePageMixin, defaultViewMixin,productDetailMixin],
  data() {
    return {
      selectBrand: null,
      curveProperties: [],
      productProperties: [],
      productSeriesId: null,
      productSeriesName: null,
      pageNo: 1,
      pageSize: 20,
      tableBox: null,
      tableHeight: 0,
      selectingIndex: -1,
      orderBy: null,
      orderType: null,
      showFilterSearch: true,
      feedbackDialogVisible: false,
    }
  },
  watch:{
    '$route.params.categoryCode':{
      // 监听了路由参数，页面又是keepalive缓存的，所以需要判断页面是否是激活状态，且不可使用immediate:true来代替created钩子函数。
      handler(newVal) {
        if(!this.activatedFlag || (!newVal && newVal !==0)) return
        this.productSeriesId = null
        this.productSeriesName = null
        this.selectBrand = null
        this.curveProperties = []
        this.productProperties = []
        this.pageNo = 1
        this.orderBy = null
        this.orderType = null
        this.initPage()
      },
    },
    tableData:{
      handler(){
        this.$nextTick(()=>{
          this.$refs.fixedColTable.doLayout()
        })
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      allProperties: 'list/allProperties',
      aggProperties: 'list/aggProperties',
      products: 'list/products',
      samplesMapping: 'list/samplesMapping',
      brands: 'list/brands',
      totalCount: 'list/totalCount',
      productsLoading: 'list/productsLoading',
      brandCode: 'brandCode',
      productClassifications: 'classification/productClassifications',
      // 由选型首页带过来的搜索条件
      currentBrands: 'fastSearch/currentBrands',
      curveSearchValues: 'fastSearch/curveSearchValues',
      propertySearchValues: 'fastSearch/propertySearchValues',
      existFeedbackVisit: 'list/existFeedbackVisit',
      isFromEntrance: 'isFromEntrance',
      selectionParams: 'selectionParams'
    }),
    gjwCategoryCode(){
      return this.$route.params.categoryCode
    },
    gjwCategoryName() {
      return this.productClassification && this.productClassification.name ? this.productClassification.name : ''
    },
    productClassification(){
      let productClassifications = this.productClassifications
      let gjwCategoryCode = this.gjwCategoryCode
      if(!productClassifications || !gjwCategoryCode) return {}
      return productClassifications.find(x=>x.code === gjwCategoryCode) || {}
    },
    showResource(){
      let productClassification = this.productClassification
      if(!productClassification || !productClassification.configItemValues) return false
      let configItemValue = productClassification.configItemValues.find(x=>x.code === 'isCanRelateResources' && x.value === 'true')
      return !!configItemValue
    },
    showUnsatisfiedInfo() {
      return this.tableData.length && this.tableData.length < 5
    },
    curveFormItems() {
      let getCurveFormItems = ProductStrategy.getCurveFormItems(this.gjwCategoryCode, this.allProperties)
      if (!this.selectionParams) {return getCurveFormItems}
      if(getCurveFormItems.length && this.selectionParams.length){
          getCurveFormItems.forEach((v,index)=>{
          v.required = true
          this.selectionParams.forEach((j) => {
            if (v.code === j.code) {
              getCurveFormItems[index].value = j.value
            }
          })
        })
      }
      return getCurveFormItems
    },
    curveSearchNames(){
      return this.curveFormItems.map(x=>x.label)
    },
    searchProperties() {
      return ProductStrategy.getSearchProperties(this.gjwCategoryCode, { aggProperties:this.aggProperties })
    },
    columns() {
      return ProductStrategy.getColumns(this.gjwCategoryCode, {allProperties:this.allProperties,curveProperties:this.curveProperties})
    },
    tableData() {
      return ProductStrategy.getTableData(this.gjwCategoryCode, {products:this.products,allProperties:this.allProperties, samplesMapping:this.samplesMapping})
    },
    selectedBrandUrl() {
      if (this.selectBrand) {
        const selectBrandItem = this.brands.find((item) => item.brandCode === this.selectBrand) || {}
        return selectBrandItem.brandUrl
      }
      return null
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    ...mapMutations({
      setShopAnimation: 'setShowShopAnimation',
      setCurveSearchValues: 'fastSearch/setCurveSearchValues',
      setPropertySearchValues: 'fastSearch/setPropertySearchValues'
    }),
    ...mapActions({
      loadBrands: 'list/loadBrands',
      loadAggBrands: 'list/loadAggBrands',
      loadAllProperties: 'list/loadAllProperties',
      loadAggProperties: 'list/loadAggProperties',
      loadProducts: 'list/loadProducts',
      loadExistFeedbackVisit: 'list/existFeedbackVisit',
    }),
    async initPage(){
      // 获取品牌
      this.loadBrands({ gjwCategoryCode: this.gjwCategoryCode })
      // 获取品类下属性列表及品类下属性扩展属性信息
      await this.loadAllProperties({ gjwCategoryCode: this.gjwCategoryCode })
      this.selectBrand = this.currentBrands
      await this.setProperties()
      // 查询产品列表
      this.getList()
      if (this.platform === 'r') {
        this.loadDefinitions({ gjw_category_code: this.gjwCategoryCode })
      }
    },
    setProperties() {
      if (!this.selectionParams || !this.selectionParams.seltectdObjs || !this.selectionParams.seltectdObjs.length) {
        this.curveProperties = [...this.curveSearchValues]
        this.productProperties = [...this.propertySearchValues]
        return
      }
      this.curveProperties = []
      this.productProperties = []
      this.selectionParams.seltectdObjs.forEach(selectionParam=>{
        if (selectionParam.type === 'Enum') {
          const selectedParam = this.allProperties.find(f=>f.code === selectionParam.code)
          if (selectedParam) {
            const values = selectionParam.value.split(',')
            if (values) {
              values.forEach(a=>{
                const propertiesEnumValue = selectedParam.enumValues.find(f=>f.code === a)
                if (propertiesEnumValue) {
                  this.productProperties.push({
                    gdParams: 1,
                    code: selectionParam.code,
                    dataType: 'Enum',
                    label: selectionParam.name,
                    parameterType: 'Enums',
                    queryType: 'ENUM',
                    suffix: null,
                    required: false,
                    valueCode: propertiesEnumValue.code,
                    valueName: propertiesEnumValue.name
                  })
                }
              })
            }
          }
        } else {
          this.curveProperties.push({
            gdParams: 1,
            code: selectionParam.code,
            label: selectionParam.name,
            value: selectionParam.value,
            required: true,
          })
        }
      })
      this.setCurveSearchValues([...this.curveProperties])
      this.setPropertySearchValues([...this.productProperties])
    },
    getTableBoxHeight(obj) {
      const height = obj.newValue - 30 > 0 ? obj.newValue - 30 : 30
      this.tableHeight = height.toFixed(0)
    },
    clickBrand(brand) {
      if (brand.disabled) { return }
      this.selectBrand = this.selectBrand === brand.brandCode ? null : brand.brandCode
      this.search()
    },
    closeFeedbackDialog() {
      this.feedbackDialogVisible = false
    },
    /**
     * 获取产品列表和聚合属性列表
     * @param refreshProperty boolean, 是否刷新属性列表 默认需要处理
     */
    getList(refreshProperty = true) {
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        return {
          code: c.code,
          value: c.value,
          deviationRate: c.deviationRate
        }
      }) : null
      let productProperties = this.productProperties.reduce((arr, p) => {
        if (p.code === 'productSeries') {
          this.productSeriesId = p.valueCode
          this.productSeriesName = p.valueName
        } else if (arr.some((s) => s.code === p.code)) {
          arr.find((f) => f.code === p.code).values.push(p.valueCode)
        } else {
          arr.push({
            code: p.code,
            parameterType: p.parameterType,
            queryType: p.queryType,
            values: [p.valueCode]
          })
        }
        return arr
      }, [])
      productProperties = productProperties.length ? productProperties : null
      if (productProperties) {
        productProperties = productProperties.filter((f) => f.code)
      }
      const params = {
        gjwCategoryCode: this.gjwCategoryCode,
        brandCode: this.selectBrand || null,
        productSeriesId: this.productSeriesId || null,
        productSeriesName: this.productSeriesName || null,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        curveProperties,
        productProperties,
        orderBy: this.orderBy,
        orderType: this.orderType
      }
      this.loadProducts(params).then(() => {
        this.searchTrack(params)
        if (refreshProperty) {
          // 重新聚合筛选条件
          const paramsForBrand = {
            gjwCategoryCode: this.gjwCategoryCode,
            // productSeriesId: this.productSeriesId || null,
            // curveProperties,
            // productProperties,
          }
          this.loadAggBrands(paramsForBrand)
          const paramsForProperties = {
            ...paramsForBrand,
            // brandCode: this.selectBrand || null,
          }
          // 筛选条件取消聚合
          if (localStorage.getItem('isSelect') !== '1') {
            this.loadAggProperties(paramsForProperties)
            this.loadAggProductSeries(paramsForProperties)
          }
        }
        const isNotDefaultSearchCondition = !!(this.selectBrand || this.productSeriesId || curveProperties || productProperties)
        if (isNotDefaultSearchCondition) {
          this.loadExistFeedbackVisit({classification_code: this.gjwCategoryCode}).then(()=>{
            if (!this.existFeedbackVisit) {
              setTimeout(() => {
                this.feedbackDialogVisible = true
              }, 2000)
            }
          })
        }
      })
    },
    search() {
      this.pageNo = 1
      this.getList()
    },
    // 性能筛选
    searchByCurve(curveProperties) {
      this.curveProperties = curveProperties
      this.search()
    },
    currentChange(val) {
      this.pageNo = val
      this.getList(false)
    },
    // 选中项目 基础选型 无运行值
    async toSelected(row, index) {
      try {
        this.selectingIndex = index
        this.setShopAnimation(false)
        // 判断当前用户是否登录
        const res = await this.checkLogin()
        if (res) {
          const designProperties =  this.getDesignProperties(row, true)
          const runtimeProperties = this.getRunTimeProperties(row)
          const payload = {
            productId: row.id,
            designProperties,
            runtimeProperties
          }
          await this.handleSelectProduct(payload)
          this.$nextTick(() => {
            this.setShopAnimation(true)
          })
          this.selectTrack({
            productId: row.id,
            gjwCategoryCode: this.gjwCategoryCode,
            gjwCategoryName: row.gjwCategoryName,
            source: 'products'
          })
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.selectingIndex = -1
      }
    },
    // 产品查询埋点
    async searchTrack(params) {
      const productResult = []
      const brandResult = []
      if (this.tableData && this.tableData.length) {
        this.tableData.forEach((item) => {
          productResult.push({ id: item.id, name: `${item.name}_${item.model}` })
          if (item.brandName && !brandResult.includes(item.brandName)) {
            brandResult.push(item.brandName)
          }
        })
      }
      const curveProperties = this.searchWithCurveProperties ? this.curveProperties.map((c) => {
        return {
          code: c.code,
          value: c.value,
          deviationRate: c.deviationRate,
          unit: c.unit
        }
      }) : null
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'productQuery',
        params: {
          g_c_keyword: params.keyword,
          g_c_class_code: params.gjwCategoryCode,
          g_c_class_name: this.productClassification.name,
          g_c_property: {
            curveProperties: curveProperties,
            productProperties: params.productProperties,
          },
          g_c_brand_code: params.brandCode,
          g_c_product_series: params.productSeriesName,
          g_c_non_filter_condition: {
            page: params.pageNo,
            page_size: params.pageSize,
          },
          g_c_product_result: productResult,
          g_c_brand_result: brandResult,
          g_c_result_count: this.totalCount,
          g_c_order_by: params.orderBy,
          g_c_order_type: params.orderType,
          g_c_default_condition: this.defaultView,
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
      // 只有第一次进入页面是缺省，再次打点都认为是false
      if (this.defaultView) {
        this.defaultView = false
      }
    },
    onSortChange({ prop, order }) {
      this.pageNo = 1
      if (order) {
        this.orderBy = prop
        this.orderType = order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.orderBy = null
        this.orderType = null
      }
      this.getList()
    },
    clearCurveFilter() {
      this.$refs.curveSearch && this.$refs.curveSearch.clearData()
      this.searchByCurve([])
    },
    clearDeviationFilter(deviation) {
      this.$refs.curveSearch && this.$refs.curveSearch.clearDeviation(deviation)
      const property = this.curveProperties.find((c) => c.code === deviation.code)
      if (property) { property.deviationRate = null }
      this.search()
    },
    clearProductFilter(product) {
      if (product.code === 'productSeries') {
        this.productSeriesId = null
        this.productSeriesName = null
      }

      this.productProperties = this.productProperties.filter((f) => !(f.code === product.code && f.valueCode === product.valueCode))

      this.$refs.filterSearch && this.$refs.filterSearch.updateSearchForm(product)
      // 重新请求产品列表和筛选条件
      this.search()
    },
    clearAllFilters() {
      this.$refs.curveSearch && this.$refs.curveSearch.clearData()
      this.curveProperties = []
      this.productProperties = []
      this.productSeriesId = null
      this.productSeriesName = null
      this.$refs.filterSearch && this.$refs.filterSearch.resetSearchForm()
      this.search()
    },
    /** 处理筛选逻辑 */
    onFilterSelected(select) {
      if (select.code === 'productSeries') {
        this.productSeriesId = select.valueCode
        this.productSeriesName = select.valueName
        this.productProperties = this.productProperties.filter((s) => s.code !== select.code)
        this.productProperties.push(select)
      } else {
        // 数据不为当前选中的大类
        this.productProperties = this.productProperties.filter((s) => select.some((item) => s.code !== item.code))
        if (!(select.length === 1 && select[0].valueCode === null)) {
          select.forEach((v) => {
            this.productProperties.push({ ...v })
          })
        }
      }
      this.search()
    },
    handleShowFilterSearch(val) {
      this.showFilterSearch = val
    },
    getDesignProperties(row, isToSelect = false) {
      return ProductStrategy.getDesignProperties(this.gjwCategoryCode, {
        allProperties: this.allProperties,
        curveProperties: this.curveProperties,
        row,
        isSingleSpeed: null,
        emptyValue: isToSelect ? '-' : null
      })
    },
    getRunTimeProperties(row, isToSelect = false) {
      return ProductStrategy.getRunTimeProperties(this.gjwCategoryCode, {
        row,
        isSingleSpeed:null,
        emptyValue: isToSelect ? '-' : null
      })
    },
    fmtValue(row, col) {
      const colProp = col.property
      return this.$fmtValue(row[colProp], '-')
    }
  },
}
</script>

<style lang="less" scoped>

  .product-list{
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .search-box, .result-row{
      flex: none;
    }
    .table-box{
      flex: 1 1 100px;
      overflow: hidden;
    }
    .empty-list-feedback{
      cursor: pointer;
      font-style: normal;
      font-weight: bold;
      color: @theme-color;
    }
  }
  .search-block{
    position: relative;
    display: flex;
    padding: 6px 0;
    line-height: 28px;
    .label{
      min-width: 56px;
      height: 20px;
    }

    .switch{
      margin: 4px 16px 4px 0;
    }
  }
  .brand-tag{
    display: inline-block;
    padding: 0 12px;
    cursor: default;
    &:hover{
      color: @theme-hover-color;
    }
    &.active{
      border-radius: 2px;
      color: @white;
      background: @theme-color;
    }
    &.active:hover{
      background: @theme-hover-color;
    }
    &.disabled{
      cursor: not-allowed;
      color: @theme-text-light;
    }
  }
  .result-row{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .result{
    height: 26px;
    line-height: 26px;
  }
  .feedback-info{
    height: 45px;line-height: 45px;
    text-align: center;
    position: relative;
    font-size: 12px;
    &::after{
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      bottom: 0;
      left: 0;
      background-color: #ebeef5;
    }
  }
</style>
